import { Component, OnInit, ViewChild } from '@angular/core';
import { JsonEditorComponent, JsonEditorOptions } from 'ang-jsoneditor';
import { RequestPropertyDatasource } from '../../../core/datasource/request-property-datasource';
import { IRequestProperty } from '../../../core/interfaces/request-property.interface';
import { BehaviorSubject } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { ScrollTopService } from '../../../core/services/scroll-top.service';
import { Title } from '@angular/platform-browser';
import { IUserInformation } from '../../../core/interfaces/user/user-information';
import { LocalStorageService } from '../../../core/services/local-storage.service';

@Component({
  selector: 'app-index',
  templateUrl: './index.component.html',
  styleUrls: ['./index.component.scss']
})
export class IndexComponent implements OnInit {

  public dataSourceProperties: RequestPropertyDatasource | null;
  public properties: BehaviorSubject<IRequestProperty[]> = new BehaviorSubject<IRequestProperty[]>(this.getRequestProperties());

  public dataSourceStatus: RequestPropertyDatasource | null;
  public statuses: BehaviorSubject<IRequestProperty[]> = new BehaviorSubject<IRequestProperty[]>(this.getStatusProperty());
  public dataSourceSubstatus: RequestPropertyDatasource | null;
  public substatus: BehaviorSubject<IRequestProperty[]> = new BehaviorSubject<IRequestProperty[]>([]);

  public dataSourceOpenEvents: RequestPropertyDatasource | null;
  public openEvents: BehaviorSubject<IRequestProperty[]> = new BehaviorSubject<IRequestProperty[]>(this.getOpenEventsProperty());

  public dataSourceClickEvents: RequestPropertyDatasource | null;
  public clickEvents: BehaviorSubject<IRequestProperty[]> = new BehaviorSubject<IRequestProperty[]>(this.getClickEventProperty());

  public dataSourceBouncedInfo: RequestPropertyDatasource | null;
  public bouncedInfo: BehaviorSubject<IRequestProperty[]> = new BehaviorSubject<IRequestProperty[]>(this.getBouncedInfoProperty());

  public dataSourceComplaintInfo: RequestPropertyDatasource | null;
  public complaintInfo: BehaviorSubject<IRequestProperty[]> = new BehaviorSubject<IRequestProperty[]>(this.getComplaintInfoProperty());

  public displayedColumns = ['property', 'type', 'description'];

  public example: any;
  public jsonEditor: any;

  public fragment: any;
  private fragmentDictionary: { [key: string]: boolean } = {
    ["email-request-complaint-info"]: false,
    ["email-request-bounced-info"]: false,
    ["email-request-click-events"]: false,
    ["email-request-open-events"]: false,
    ["email-status"]: false,
    ["email-request-status"]: false,
    ["request-sample"]: false
  };

  public csharpCode: any;
  public jsCode: any;
  public pythonCode: any;
  public javaCode: any;

  public userInfo: IUserInformation = null;

  public editorOptions: JsonEditorOptions;
  @ViewChild(JsonEditorComponent) jsonTextEditor: JsonEditorComponent;

  constructor(private route: ActivatedRoute,
    private localStorageService: LocalStorageService,
    private title: Title) {
    this.title.setTitle("Dillo Docs | Email");

    this.editorOptions = new JsonEditorOptions();
    this.editorOptions.mode = 'code';

    this.userInfo = this.localStorageService.getUserInfo();
  }

  ngOnInit() {
    //this.scrollTopService.setScrollTop();

    this.example = JSON.parse('{"id":"24f6ff94-9e8f-4426-bda6-0f7f3cb782c0","sender":"sample@sample.com","senderDisplayName":"Dillo","email":"customer.customer@test.com","content":"Hello! We are happy to inform you that Dillo is able to send emails! Click the following link for more info:...","createdOnUtc":"2020-05-08T13:11:59.1924557Z","updatedOnUtc":"2020-05-08T13:12:05.7385218Z","price":1.5,"customerCode":"testCustomer","status":{"partitionKey":"TopicItemStatus","primaryStatus":{"partitionKey":"Status","code":200,"description":"Success"},"secondaryStatus":{"partitionKey":"Status","code":20,"description":"Delivered"},"statusCode":"200.20"},"enableTracking":true,"replyTo":null,"openEvents":[{"id":"02b0d110-4fa9-48ca-9467-0b7f5e690cfe","partitionKey":"OpenEvent","userAgent":"Mozilla/5.0 (Windows NT 5.1; rv:11.0) Gecko Firefox/11.0 (via ggpht.com GoogleImageProxy)","ipAddress":"66.249.81.156","openOnUtc":"2020-05-08T13:12:22.933Z"}]}')

    this.dataSourceProperties = new RequestPropertyDatasource(this.properties);
    this.dataSourceStatus = new RequestPropertyDatasource(this.statuses);
    this.dataSourceSubstatus = new RequestPropertyDatasource(this.substatus);
    this.dataSourceOpenEvents = new RequestPropertyDatasource(this.openEvents);
    this.dataSourceClickEvents = new RequestPropertyDatasource(this.clickEvents);
    this.dataSourceBouncedInfo = new RequestPropertyDatasource(this.bouncedInfo);
    this.dataSourceComplaintInfo = new RequestPropertyDatasource(this.complaintInfo);

    this.initialiseCodeSamples();

    this.substatus.next(this.getSubstatusProperties());

    this.route.fragment.subscribe(fragment => { this.fragment = fragment; });

  }

  ngAfterViewChecked(): void {
    try {
      var key = this.fragment;
      if (this.fragmentDictionary.hasOwnProperty(key) && this.fragmentDictionary[key] == true) {
        return;
      }
      else {
        if (this.fragment) {
          document.querySelector('#' + this.fragment).scrollIntoView();
          this.fragmentDictionary[key] = true;
        }
      }
    } catch (e) { }
  }

  setValueFalse() {
    this.fragmentDictionary[this.fragment] = false;
  }

  getRequestProperties(): IRequestProperty[] {
    return [
      { property: 'Id', type: 'Guid', description: 'The request id', value: '' },
      { property: 'Sender', type: 'String', description: 'The email sender defined on user account', value: '' },
      { property: 'SenderDisplayName', type: 'String', description: "The display name the email recipients see", value: "" },
      { property: 'Email', type: 'String', description: "The email address to which the email was sent", value: "" },
      { property: 'Subject', type: 'String', description: "The subject of the email", value: "" },
      { property: 'Content', type: 'String', description: " The content of the email", value: "" },
      { property: 'CreatedOnUtc', type: 'DateTime', description: "The UTC date and time the request was created", value: "" },
      { property: 'UpdatedOnUtc', type: 'DateTime', description: "The UTC date and time the request was last modified", value: "" },
      { property: 'Price', type: 'decimal', description: "The total cost of sending the email", value: "" },
      { property: 'CustomerCode', type: 'string', description: "The customer who made the request", value: "" },
      { property: 'Status', type: 'EmailRequestStatus (object)', description: "The current status of the email request", value: "" },
      { property: 'EnableTracking', type: 'bool', description: "Indicates whether tracking was enabled for this email request", value: "" },
      { property: 'ReplyTo', type: 'string', description: "The email address to which the email recipients reply", value: "" },
      { property: 'OpenEvents', type: 'OpenEvents (object)', description: "A list of open events (reads)", value: "" },
      { property: 'ClickEvents', type: 'ClickEvents (object)', description: "A list of click events", value: "" },
      { property: 'BouncedInfo', type: 'BouncedInfo (object)', description: "Information about bounce", value: "" },
      { property: 'ComplaintInfo', type: 'ComplaintInfo (object)', description: "Information about complaint", value: "" },
      { property: 'RejectReason', type: 'string', description: "The reason the sending of email was rejected by Amazon SES", value: "" },

    ]
  }

  getStatusProperty(): IRequestProperty[] {
    return [
      { property: 'PrimaryStatus', type: ' EmailStatus (object)', description: 'The primary status of the request', value: '' },
      { property: 'SecondaryStatus', type: 'EmailStatus (object)', description: 'The secondary status of the request', value: '' },
      { property: 'StatusCode', type: 'String', description: "The combined values of the PrimaryStatus and SecondaryStatus", value: "" }

    ]
  }

  getOpenEventsProperty(): IRequestProperty[] {
    return [
      { property: 'UserAgent', type: 'string', description: "The user's agent", value: '' },
      { property: 'IpAddress', type: 'string', description: 'The IP address from which the email was opened', value: '' },
      { property: 'OpenOnUtc', type: 'DateTime', description: "The UTC date when the email has been opened", value: "" }
    ]
  }

  getClickEventProperty(): IRequestProperty[] {
    return [
      { property: 'Link', type: 'string', description: 'The link that has been clicked', value: '' },
      { property: 'ClickedOnUtc', type: 'DateTime', description: 'The UTC date of the click event', value: '' },
      { property: 'UserAgent', type: 'string', description: "The user's agent", value: "" },
      { property: 'IpAddress', type: 'string', description: 'The IP address from which the link was clicked', value: '' },
    ]
  }

  getBouncedInfoProperty(): IRequestProperty[] {
    return [
      { property: 'BounceType', type: 'string', description: 'The bounce main type (transient, permanent)', value: '' },
      { property: 'BounceSubtype', type: 'string', description: "The bounce subtype (reason for bounce)", value: "" },
      { property: 'CreatedOnUtc', type: 'DateTime', description: 'The UTC date the email has been bounced', value: '' }
    ]
  }

  getComplaintInfoProperty(): IRequestProperty[] {
    return [
      { property: 'ComplaintType', type: 'string', description: 'The complaint type (reason for complaint)', value: '' },
      { property: 'ComplaintSubtype', type: 'string', description: "The complaint subtype (can be null)", value: "" },
      { property: 'CreatedOnUtc', type: 'DateTime', description: 'The UTC date of the complaint', value: '' }
    ]
  }

  getSubstatusProperties(): IRequestProperty[] {
    return [
      { property: 'Code', type: ' integer', description: 'The status code', value: '' },
      { property: 'Description', type: 'string', description: 'The status short description', value: '' },

    ]
  }

  initialiseCodeSamples() {

        this.csharpCode = `
      //replace CustomerCode and ApiKey with your own.
      DilloEmailClient.Init("${ this.userInfo.customerCode != null ? this.userInfo.customerCode : "[your customer code]"}", "${this.userInfo.apiKey != null ? this.userInfo.apiKey : "[your api key]"}");

      OutboundEmailPostResponse postResponse = new OutboundEmailPostResponse
      {
          Id = new Guid("c00ac235-d401-4edb-8ea3-675a108f380b"),
          IsSuccess = true
      };
      OutboundEmailGetResponse getResponse = await postResponse.GetAsync();`;


        this.jsCode = `var settings = {
      "url": "https://api.dillo.cloud/api/sendaction/email/24f6ff94-9e8f-4426-bda6-0f7f3cb782c0",
      "method": "GET",
      "timeout": 0,
      "headers": {
         "ApiKey": "${ this.userInfo.apiKey != null ? this.userInfo.apiKey : "[your api key]"}",
         "CustomerCode": "${ this.userInfo.customerCode != null ? this.userInfo.customerCode : "[your customer code]"}",
      },
    };

    $.ajax(settings).done(function (response) {
      console.log(response);
    });`


        this.javaCode = `OkHttpClient client = new OkHttpClient().newBuilder()
      .build();
    Request request = new Request.Builder()
      .url("https://api.dillo.cloud/api/sendaction/email/24f6ff94-9e8f-4426-bda6-0f7f3cb782c0")
      .method("GET", null)
      .addHeader("ApiKey", "${ this.userInfo.apiKey != null ? this.userInfo.apiKey : "[your api key]"}")
      .addHeader("CustomerCode", "${ this.userInfo.customerCode != null ? this.userInfo.customerCode : "[your customer code]"}")
      .build();
    Response response = client.newCall(request).execute();`

        this.pythonCode = `import http.client
    import mimetypes
    conn = http.client.HTTPSConnection("api.dillo.cloud")
    payload = ''
    headers = {
      'ApiKey': '${ this.userInfo.apiKey != null ? this.userInfo.apiKey : "[your api key]"}',
      'CustomerCode': '${ this.userInfo.customerCode != null ? this.userInfo.customerCode : "[your customer code]"}',
    }
    conn.request("GET", "/api/sendaction/email/24f6ff94-9e8f-4426-bda6-0f7f3cb782c0", payload, headers)
    res = conn.getresponse()
    data = res.read()
    print(data.decode("utf-8"))`;
  }

}
